export const Laterality = {
  NONE: 0,
  LEFT: 1,
  RIGHT: 2,
  BOTH: 3,
} as const;

export const LateralityLabels: Record<number, string> = {
  [Laterality.NONE]: "Δεν έχει οριστεί",
  [Laterality.LEFT]: "Αριστερό",
  [Laterality.RIGHT]: "Δεξί",
  [Laterality.BOTH]: "Αμφότερα",
};

export const Gender = {
  NONE: 0,
  MALE: 1,
  FEMALE: 2,
  OTHER: 3,
} as const;

export const GenderLabels: Record<number, string> = {
  [Gender.NONE]: "Δεν έχει οριστεί",
  [Gender.MALE]: "Άρρεν",
  [Gender.FEMALE]: "Θήλυ",
  [Gender.OTHER]: "Άλλο",
};

export const AuditActions = {
  NONE: 0,
  INSERT: 1,
  UPDATE: 2,
  DELETE: 3,
} as const;

export type AuditActionType = (typeof AuditActions)[keyof typeof AuditActions];

export const AuditActionsLabels: Record<AuditActionType, string> = {
  [AuditActions.NONE]: "Δεν έχει οριστεί",
  [AuditActions.INSERT]: "Εισαγωγή",
  [AuditActions.UPDATE]: "Τροποποίηση",
  [AuditActions.DELETE]: "Διαγραφή",
};

export const RvStatus = {
  SCHEDULED: 1,
  CANCELLED: 2,
  COMPLETED: 3,
} as const;

export type RvStatusType = (typeof RvStatus)[keyof typeof RvStatus];

export const RvStatusLabels: Record<RvStatusType, string> = {
  [RvStatus.SCHEDULED]: "Scheduled",
  [RvStatus.CANCELLED]: "Cancelled",
  [RvStatus.COMPLETED]: "Completed",
};

export const DocumentFormat = {
  NONE: 0,
  PDF: 1,
  IMAGE: 2,
  DICOM: 3,
  WORD: 4,
} as const;

export const DocumentFormatLabels: Record<number, string> = {
  [DocumentFormat.NONE]: "Άγνωστο",
  [DocumentFormat.PDF]: "PDF",
  [DocumentFormat.IMAGE]: "Εικόνα (Image)",
  [DocumentFormat.DICOM]: "DICOM (Ιατρική Εικόνα)",
  [DocumentFormat.WORD]: "Word Document",
};

export const TableNameLabels: Record<string, string> = {
  Alert: "Ειδοποιήσεις",
  Allergy: "Αλλεργίες",
  AuditLog: "Καταγραφές Ελέγχου",
  ClinicalAlert: "Κλινικές Ειδοποιήσεις",
  Disease: "Ασθένειες",
  Doctor: "Ιατροί",
  DocumentType: "Κατηγορίες Αποτελεσμάτων",
  Encounter: "Επισκέψεις / Περιστατικά",
  GdprConsent: "Συναίνεσεις GDPR",
  GdprDocument: "Έγγραφα GDPR",
  Implant: "Εμφυτεύματα",
  LoginLog: "Καταγραφές Εισόδου",
  Medicine: "Φάρμακα",
  MedicineDose: "Δόσεις Φαρμάκων",
  Patient: "Ασθενείς",
  PatientAllergy: "Αλλεργίες Ασθενών",
  PatientClinical: "Κλινικά Δεδομένα Ασθενών",
  PatientClinicalScore: "Κλινικές Βαθμολογίες Ασθενών",
  PatientDocument: "Έγγραφα Ασθενών",
  PatientGdprConsent: "Συναίνεσεις GDPR Ασθενών",
  PatientImplant: "Εμφυτεύματα Ασθενών",
  PatientRecord: "Ιατρικοί Φάκελοι Ασθενών",
  PatientRehabProtocol: "Πρωτόκολλα Αποκατάστασης Ασθενών",
  PatientSurgery: "Χειρουργεία Ασθενών",
  PatientUuid: "UUID Ασθενών",
  PatientsMedicine: "Φάρμακα Ασθενών",
  RecordCategory: "Κατηγορίες Ιστορικού",
  RehabFacility: "Δομές Αποκατάστασης",
  RehabFacilityDetail: "Λεπτομέρειες Δομών Αποκατάστασης",
  RehabProtocol: "Πρωτόκολλα Αποκατάστασης",
  Right: "Δικαιώματα",
  Rv: "Ραντεβού",
  Specialty: "Ιατρικές Ειδικότητες",
  SurgeryType: "Τύποι Χειρουργείων",
  User: "Χρήστες",
  UsersRight: "Δικαιώματα Χρηστών",
} as const;
